/**
 * Extracts the first name from a full name string.
 * Handles extra whitespace, titles, and compound structures cleanly.
 *
 * @param {string} fullName
 * @param {string} fallback
 * @returns {string}
 */
export const getFirstName = (fullName, fallback = 'طالب DATX') => {
  if (!fullName || typeof fullName !== 'string') {
    return fallback;
  }

  const trimmed = fullName.trim();
  if (!trimmed) {
    return fallback;
  }

  // Split by whitespace
  const parts = trimmed.split(/\s+/);
  return parts[0] || fallback;
};

export default getFirstName;
